import React from 'react';

function PageHeaderWithButtons(props) {
    return (
        <div className="page-header-with-buttons">
            <span
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'baseline'
                }}
            >
                <div className="page-header">{props.header}</div>
                {props.subheader && (
                    <div className="page-sub-header">{props.subheader}</div>
                )}
            </span>
            <span style={{ display: 'flex', flexDirection: 'row' }}>
                {props.buttons && props.buttons.map(button => button)}
            </span>
        </div>
    );
}

export default PageHeaderWithButtons;
